import { render, staticRenderFns } from "./SmsTemplateSelect.vue?vue&type=template&id=20a50af7"
import script from "./SmsTemplateSelect.vue?vue&type=script&lang=js"
export * from "./SmsTemplateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports